import { MyImpact, MyImpactTranslatable } from './MyImpact';
import MyImpactPage from './MyImpactPage';

export { MyImpact, MyImpactTranslatable, MyImpactPage };
